import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from 'components/Breadcrumbs'
import { hasBreadcrumbLinks } from 'utils/breadcrumbHelpers'

import { HeaderRow } from './component.styles'

/**
 * Renders the CMS breadcrumb with the site selector (children) on the same
 * row. Pages pass a `className` (via `styled(BreadcrumbHeaderRow)`) to match
 * the row's edges to their content. Without a breadcrumb only the children
 * render, so the site selector keeps its original layout.
 */
const BreadcrumbHeaderRow = ({
  breadcrumb,
  children,
  className,
  isLight = false,
}) => {
  if (!hasBreadcrumbLinks(breadcrumb)) {
    return children ?? null
  }

  return (
    <HeaderRow className={className} data-testid="breadcrumb-header-row">
      <Breadcrumbs breadcrumb={breadcrumb} isLight={isLight} />
      {children}
    </HeaderRow>
  )
}

BreadcrumbHeaderRow.propTypes = {
  breadcrumb: PropTypes.shape({
    route: PropTypes.arrayOf(
      PropTypes.shape({
        displayTitle: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
  }),
  children: PropTypes.node,
  className: PropTypes.string,
  isLight: PropTypes.bool,
}

export default BreadcrumbHeaderRow
